const Joi = require("joi");

const registeredUserSchema = (data) => {
  const schema = Joi.object({
    UserStatus: Joi.number()
      .integer() // Ensures it is an integer
      // .invalid(0) // Mark 0 as invalid
      .required() // Still mark the field as required
      .messages({
        "number.base": "Please select User Status.",
        "any.required": "Please select User Status.",
        "any.only": "Please select User Status.", // Custom message for null value
        // "any.invalid": "The UserStatus field is required.", // Custom message for invalid (0) value
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = registeredUserSchema;
